<template>
    <div v-show="isAddLicenseSuccessModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
                    <div class="modal-content p-2">
                        <div class="modal-header">
                            <div class="maheading_2">
                                <h5 class="modal-title">Purchase {{ unitType }}s</h5>
                            </div>
                            <div class="maheading_3">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row mt-4 justify-content-md-center">
                                <div class="col-9">
                                    <div class="successPanel">
                                        <div class="success_col_1">
                                            <p class="success-msg">Success!</p>
                                            <p class="success-note" v-if="paymentMethod == 'credit_card'">
                                                <i class="fa fa-check-circle-o"></i> {{ unitType }}s successfully added
                                            </p>
                                            <p class="success-note" v-else>
                                                <i class="fa fa-check-circle-o"></i> Invoice successfully created
                                            </p>
                                        </div>
                                        <div class="success_col_2">
                                            <img src="@/assets/enterprise/Required_Rocket_Image_106x101.png" width="70" />
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="success_col_3" v-if="invoice_filename">
                                            <a :href="viewPDFUrl + invoice_filename" target="_blank" class="linkable" v-if="paymentMethod == 'credit_card'"> View Receipt </a>
                                            <a :href="viewPDFUrl + invoice_filename"  target="_blank" class="linkable" v-else> View Invoice </a>
                                        </div>
                                        <div class="success_col_3" v-if="annualSubscription == true">
                                          On next billing date {{ billingDate }}, Annual billing price ${{ packageYearlyPrice }}.00 will be charged for the {{ packageName }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                         
                            <div class="row mt-4 justify-content-md-center">
                                <div class="col-12 text-center">
                                    <button type="button" class="btn-sm closeBtn text-center" @click="closeModal">Close Window</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import router from '../../router/index.js';

export default {
    props: ['isAddLicenseSuccessModalVisible', 'paymentMethod', 'invoice_filename', 'landingPage', 'unitType', 'packageYearlyPrice', 'billingDate', 'annualSubscription', 'packageName'],
    data() {
        return {
            loading: false,
            isModalVisible: false,
            viewPDFUrl: '',
        }
    },    
    methods: {
        hide() {
            this.closeModal();
        },
        closeModal() {
            let routeData = this.$router.resolve({name: this.landingPage});
            window.open(routeData.href, '_self');
            // this.isAddLicenseSuccessModalVisible = false;
            // this.$parent.$parent.closeLicenseModal();
        },
    },
    mounted() {
       this.viewPDFUrl = process.env.API_ENDPOINT + '/web/reports/';
    }

}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 80%; }
.maheading_3 { width: 20%; }
.successPanel { 
    background-color: #28a745;
    color: #FFF;
    padding: 20px;
    border-radius: 10px;
    min-height: 180px;
}
.success-msg { font-size:  1.1rem; font-weight: 900;}
.success-note i { font-size: 1.05rem; margin-right: 10px; }
.gotoBtn { margin-top: 0rem; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.list_row_margin { margin: 2rem 0; }
.list_items { list-style-type: decimal; }
.list_items li { margin: 15px 0; }
.success_col_1 { width: 70%; float: left; }
.success_col_2 { width: 30%; float: left; }
.success_col_3 { width: 100%; text-align: center; margin-top: 30px; }
.linkable { color: #FFF !important; text-decoration: none !important; font-weight: 900; cursor:pointer; font-size:  1.1rem }
</style>



// WEBPACK FOOTER //
// src/components/manager/add_license_success_modal.vue